import React from 'react'
import hoistNonReactStatics from 'hoist-non-react-statics'
import { ReactReduxContext } from 'react-redux'
import getInjectors from './sagaInjectors'

export default ({ key, saga, mode, dynamic = false }) => WrappedComponent => {
  class InjectSaga extends React.Component {
    static WrappedComponent = WrappedComponent

    static contextType = ReactReduxContext

    static displayName = `withSaga(${WrappedComponent.displayName ||
      WrappedComponent.name ||
      'Component'})`

    constructor(props, context) {
      super(props, context)
      this.injectors = getInjectors(context.store)
      this.sagaKey = dynamic ? props.sagaKey : key
      this.saga = dynamic ? props.saga : saga
      this.injectors.injectSaga(
        this.sagaKey,
        { saga: this.saga, mode },
        this.props.sagaArgs
      )
    }

    componentWillUnmount() {
      this.injectors.ejectSaga(this.sagaKey)
    }

    render() {
      const { saga, sagaKey, sagaArgs, forwardedRef, ...props } = this.props
      return <WrappedComponent ref={forwardedRef} {...props} />
    }
  }

  const ForwardedComponent = React.forwardRef((props, ref) => {
    return <InjectSaga {...props} forwardedRef={ref} />
  })

  return hoistNonReactStatics(ForwardedComponent, WrappedComponent)
}

const useInjectSaga = ({ key, saga, mode, args }) => {
  const context = React.useContext(ReactReduxContext)
  React.useEffect(() => {
    const injectors = getInjectors(context.store)
    injectors.injectSaga(key, { saga, mode }, args)
    return () => {
      injectors.ejectSaga(key)
    }
  }, [context.store, key, mode, saga, args])
}

export { useInjectSaga }
